import React from 'react';
import { useFormik } from 'formik';
import Button from '../../components/Button';
import HeadTitle from '../../components/HeadTitle';
import TagInfo from '../../components/TagInfo';
import ValidationDocument, { FieldWrapper } from '../../components/ValidationDocument';
import { maskScheduleCode, removeMask } from '../../utils/masks';
import { validateCpf, validatePassport } from '../../utils/validators';

const InfoImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warningBlue.svg';

import * as S from './styles';
import { useContextSelector } from 'use-context-selector';
import { RouterContext } from '../../contexts/RouterContext';
import { InputValidation } from '../../components/InputValidation';
import { PAGES } from '../../Router/pages';
import ContainerPage from '../../components/ContainerPage';
import LoadingOverlay from '../../components/LoadingOverlay';
import { PlatformContext } from '../../contexts/PlatformContext';
import { gtmEvent } from '../../utils/gtm';
// import { fetchAppointment } from '../../modules/unifiedAppointments';
import { fetchAppointment, fetchAppointmentSpecialist } from '../../modules/slots';
import { toast } from 'react-toastify';
import { AxiosError } from 'axios';
import { Page, useMainRouter } from '../../Router/pageComponents';

const ConsultAppointment = () => {
  const { goTo } = useContextSelector(RouterContext, state => state);
  const { setIsSchedulerOpen, clearData } = useContextSelector(PlatformContext, state => state);
  const [validDocument, setValidDocument] = React.useState(false);
  const [showConfirmIdentity, setShowConfirmIdentity] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const { navigate } = useMainRouter();

  const formik = useFormik({
    initialValues: {
      documentType: 'CPF',
      document: '',
      appointmentCod: ''
    },
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async values => {
      if (validateForm(values)) {
        const document = removeMask(values.document);
        setLoading(true);
        gtmEvent({
          event: 'agendamento-einstein',
          categoria: 'consultar-agendamento',
          acao: 'step-2',
          rotulo: 'infos-agendamento'
        });

        try {
          const resultResponse = await fetchAppointment(document, values.appointmentCod);
          const resultResponseSpecialist = await fetchAppointmentSpecialist(
            document,
            values.appointmentCod,
            values.documentType
          );
          if (resultResponse.data || resultResponseSpecialist.data) {
            navigate(Page.APPOINTMENT_DETAILS, {
              appointment: {
                ...resultResponse.data,
                ...resultResponseSpecialist.data,
                specialist: !!resultResponseSpecialist.data,
                patient: { document: formik.values.document }
              }
            });
          } else {
            if (resultResponseSpecialist.message === 'Appointment are already canceled') {
              throw new Error('Esse agendamento já foi cancelado.');
            } else throw new Error('Agendamento não encontrado.');
          }
        } catch (error: any) {
          console.error(error);
          toast.error(error.message);
        }
        setLoading(false);
      }
    }
  });

  const validateForm = (props: { documentType: string; document: string; appointmentCod: string }) => {
    if (formik.values.documentType === 'CPF') {
      if (!validateCpf(props.document)) {
        formik.setFieldError('document', 'Documento inválido');
        return false;
      }
    } else if (formik.values.documentType === 'Passport') {
      if (!validatePassport(props.document)) {
        formik.setFieldError('document', 'Documento inválido');
        return false;
      }
    }

    if (props.appointmentCod.length < 7) {
      formik.setFieldError('appointmentCod', 'Código inválido');
      return false;
    }
    return true;
  };

  const handleCloseSchedule = () => {
    clearData();
    setIsSchedulerOpen(false);
  };

  const isValidForm = () => {
    if (formik.values.documentType === 'CPF') {
      return formik.values.document.length < 14 || formik.values.appointmentCod.length < 7;
    } else return formik.values.document.length < 3 || formik.values.appointmentCod.length < 7;
    return false;
  };

  return (
    <ContainerPage
      childrenFooter={<Button title="Consultar" type="button" disabled={isValidForm()} onClick={formik.submitForm} />}
    >
      <S.Form>
        <HeadTitle
          title="Consultar agendamento"
          goBack={() => {
            handleCloseSchedule();
          }}
        />
        <ValidationDocument
          setFieldValue={formik.setFieldValue}
          setFieldError={formik.setFieldError}
          document={formik.values.document}
          documentType={formik.values.documentType}
          error={formik.errors.document}
          setIsValid={setValidDocument}
          isValid={validDocument}
          onConfirmIdentity={() => {}}
          showConfirmIdentity={showConfirmIdentity}
        />
        <FieldWrapper>
          <InputValidation
            name="appointmentCod"
            id="appointmentCod"
            placeholder="Código do agendamento"
            label="Código do agendamento"
            type="text"
            onChange={e => {
              const maskedCode = maskScheduleCode(e.target.value);
              formik.setFieldValue('appointmentCod', maskedCode);
              if (maskedCode.length < 6) {
                formik.setFieldError('appointmentCod', 'Código inválido');
              } else {
                formik.setFieldError('appointmentCod', '');
              }
            }}
            filled={formik.values.appointmentCod.length === 7}
            invalid={formik.values.appointmentCod.length > 0 && formik.values.appointmentCod.length < 7}
            value={formik.values.appointmentCod}
            error={formik.errors.appointmentCod}
          />
        </FieldWrapper>
        <S.InfoWrapper>
          <TagInfo
            icon={<img src={InfoImg} alt="info" />}
            info="O código está no e-mail de confirmação do agendamento"
          />
        </S.InfoWrapper>
      </S.Form>
      <LoadingOverlay loading={loading} />
    </ContainerPage>
  );
};

export default ConsultAppointment;
